var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live_home"},[_c('liveSlide'),_c('liveHot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }